/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for trial user garbage collection job.

Scans for trial users whose trial has expired more than a configured
number of days ago and soft-deletes them.
 */
export interface TrialUserGarbageCollectionParams {
  [key: string]: unknown;
}
